import React from 'react';
import styled from 'styled-components';
import ThemeStatusTypes from '../flux/ThemeStatusTypes';
import __ from '../utils/translator';

import Completed from '../icons/Completed';
import New from '../icons/New';
import Started from '../icons/Started';
import Updated from '../icons/Updated';

const {
  THEME_STATUS_NEW,
  THEME_STATUS_STARTED,
  THEME_STATUS_COMPLETED,
  THEME_STATUS_UPDATED,
} = ThemeStatusTypes;

const defaultStatusIcons = {
  [THEME_STATUS_NEW]: props => <New {...props} />,
  [THEME_STATUS_STARTED]: props => <Started {...props} />,
  [THEME_STATUS_COMPLETED]: props => <Completed {...props} />,
  [THEME_STATUS_UPDATED]: props => <Updated {...props} />,
};

const Container = styled.span`
  display: flex;
  align-items: center;

  > span {
    padding-left: .5rem;
  }
`;

export default ({
  statusIcons = defaultStatusIcons,
  status,
  color,
  iconStyle,
  style,
  ...props
}) => (
  <Container style={{ ...style, color }}>
    {statusIcons[status]({ ...props, style: { width: '1rem', ...iconStyle }, })}
    <span>{__(status)}</span>
  </Container>
);
